module.exports = __webpack_public_path__ + "media/images/lb/654-25818af6907a64ab356ee1f4b985f7c4.svg";